import { useEffect, useState } from 'react';

/**
 * Phone width, kept in lockstep with Tailwind's `sm` breakpoint (640px): a
 * `sm:` class and this query must never disagree about which side of the line
 * a viewport is on, or a layout branches one way in CSS and the other in JS.
 */
export const PHONE_QUERY = '(max-width: 639.98px)';

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);

    onChange();
    mql.addEventListener('change', onChange);

    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
